import React from 'react';

const Projects = ({ language }) => {
  const translations = {
    de: {
      projects_title: "Aktuelle Projekte & Fokus",
      projects_subtitle: "Was mich aktuell in Beruf, Studium und Freizeit antreibt – von beruflicher Praxis und Abendstudium bis zu Smart Home, Hacking und KI-Agenten.",

      projects: [
        {
          badge: "Beruf • TÜV Trust IT",
          title: "Junior Penetration Testing (Teilzeit)",
          desc: "Praktische Sicherheitsprüfungen im Kundenauftrag. Durchführung von Penetration Tests für Webapplikationen, Client-Applikationen, Netzwerkinfrastrukturen und moderne APIs inklusive strukturierter Schwachstellenanalysen und praxisnaher Berichterstattung.",
          tags: ["Web & API Pentesting", "Burp Suite", "Netzwerk Audits", "Client Security"]
        },
        {
          badge: "Akademisch • FH Campus Wien",
          title: "MSc IT Security (Berufsbegleitendes Abendstudium)",
          desc: "Vertiefendes Masterstudium in den Abendstunden parallel zur Berufstätigkeit. Fokus auf offensive und defensive Sicherheitstechniken, Kryptographie, Incident Response, Cloud-Sicherheit und Sicherheitsarchitekturen.",
          tags: ["MSc IT Security", "Sicherheitsarchitekturen", "Incident Response", "Kryptographie"]
        },
        {
          badge: "Freizeit & Infrastruktur",
          title: "Smart Home Automation & HomeLab",
          desc: "Aufbau, Betrieb und Absicherung meines eigenen HomeLabs. Lokale Smart-Home-Automatisierung mit starkem Fokus auf Privatsphäre, VLAN-Netzwerksegmentierung, restriktive Firewall-Regeln und selbst gehostete Container-Dienste.",
          tags: ["Home Assistant", "Netzwerk-Segmentierung", "VLANs", "Docker", "Linux Server"]
        },
        {
          badge: "Security & Hacking",
          title: "Hands-on Hacking, CTFs & HTB CPTS Training",
          desc: "Kontinuierliches Praxistraining auf Plattformen wie Hack The Box, intensive Vorbereitung auf die CPTS-Zertifizierung und Teilnahme an CTF-Challenges. Erforschen realitätsnaher Exploit-Ketten, Privilege Escalation und Active Directory Domänenangriffe.",
          tags: ["Hack The Box", "Active Directory Labs", "Privilege Escalation", "CTFs", "CPTS"]
        },
        {
          badge: "Tech Innovation",
          title: "AI Agents, Tool-Use & Moderne Automatisierung",
          desc: "Experimentieren mit autonomen KI-Agenten, Tool-Use (Model Context Protocol / MCP) und smarten Automatisierungs-Workflows. Erforschung, wie moderne LLMs komplexe Coding- und Security-Aufgaben im Alltag beschleunigen und unterstützen.",
          tags: ["AI Agents", "MCP Protocols", "Automation Workflows", "Python", "Modern Tech"]
        }
      ]
    },
    en: {
      projects_title: "Current Projects & Focus",
      projects_subtitle: "What currently drives me across career, academia, and free time—from professional assessments and evening studies to smart home, hacking labs, and AI agents.",

      projects: [
        {
          badge: "Career • TÜV Trust IT",
          title: "Junior Penetration Testing (Part-Time)",
          desc: "Hands-on cybersecurity assessments for client environments. Executing penetration tests across web applications, client software, network infrastructures, and APIs, paired with structured vulnerability analysis and actionable reporting.",
          tags: ["Web & API Pentesting", "Burp Suite", "Network Audits", "Client Security"]
        },
        {
          badge: "Academia • FH Campus Wien",
          title: "MSc IT Security (Part-Time Evening Studies)",
          desc: "In-depth Master's degree in evening sessions alongside working part-time. Deep dive into offensive and defensive techniques, advanced cryptography, incident response, cloud security, and resilient system architectures.",
          tags: ["MSc IT Security", "Security Architectures", "Incident Response", "Cryptography"]
        },
        {
          badge: "Free Time & Infrastructure",
          title: "Smart Home Automation & HomeLab",
          desc: "Building, operating, and hardening a personal HomeLab and local-first smart home. Focused on privacy, network segmentation with VLANs, strict firewalling policies, and self-hosted containerized services.",
          tags: ["Home Assistant", "Network Segmentation", "VLANs", "Docker", "Linux Server"]
        },
        {
          badge: "Security & Hacking",
          title: "Hands-on Hacking, CTFs & HTB CPTS Training",
          desc: "Continuous hands-on challenges on platforms like Hack The Box, dedicated preparation for the CPTS certification, and competing in CTFs. Exploring exploit chains, privilege escalation, and Active Directory domain attacks.",
          tags: ["Hack The Box", "Active Directory Labs", "Privilege Escalation", "CTFs", "CPTS"]
        },
        {
          badge: "Tech Innovation",
          title: "AI Agents, Tool-Use & Modern Automation",
          desc: "Experimenting with autonomous AI agents, tool-calling protocols (Model Context Protocol / MCP), and intelligent workflow automation. Exploring how modern LLMs supercharge coding, scripting, and security research.",
          tags: ["AI Agents", "MCP Protocols", "Automation Workflows", "Python", "Modern Tech"]
        }
      ]
    }
  };

  const t = translations[language];

  return (
    <>
      <h2>{t.projects_title}</h2>
      <p style={{ maxWidth: '48rem', marginBottom: '2rem' }}>{t.projects_subtitle}</p>

      <div className="projects-grid">
        {t.projects.map((proj, idx) => (
          <article key={idx} className="project-card">
            <div className="project-card-header">
              <span className="project-category-badge">{proj.badge}</span>
            </div>
            <h3>{proj.title}</h3>
            <p className="project-desc">{proj.desc}</p>
            <div className="project-tags">
              {proj.tags.map((tag, tIdx) => (
                <span key={tIdx} className="project-tag-pill">{tag}</span>
              ))}
            </div>
          </article>
        ))}
      </div>
    </>
  );
};

export default Projects;